"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSISTANT_SLOT_TYPE_LABELS = exports.ASSISTANT_SLOT_TYPE_CATALOG = exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS = void 0;
exports.isAssistantSlotTypeLabel = isAssistantSlotTypeLabel;
exports.findAssistantSlotTypeCatalogEntry = findAssistantSlotTypeCatalogEntry;
/**
 * Deterministic UUIDs for the seeded global catalog records. Kept here so the
 * seed migration and runtime code reference the exact same ids.
 */
exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS = {
    Matin: 'a5107000-0000-4000-8000-000000000001',
    Soir: 'a5107000-0000-4000-8000-000000000002',
    Long: 'a5107000-0000-4000-8000-000000000003',
    Formation: 'a5107000-0000-4000-8000-000000000004',
};
/**
 * The fixed catalog of assistant slot types, in display order.
 */
exports.ASSISTANT_SLOT_TYPE_CATALOG = [
    {
        id: exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS.Matin,
        label: 'Matin',
        defaultTimeRanges: [
            { startTime: '07:30', endTime: '11:30' },
            { startTime: '11:45', endTime: '13:45' },
        ],
        countsAsOfficePresence: true,
    },
    {
        id: exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS.Soir,
        label: 'Soir',
        defaultTimeRanges: [
            { startTime: '11:30', endTime: '14:30' },
            { startTime: '15:00', endTime: '20:00' },
        ],
        countsAsOfficePresence: true,
    },
    {
        id: exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS.Long,
        label: 'Long',
        defaultTimeRanges: [
            { startTime: '08:45', endTime: '12:45' },
            { startTime: '13:45', endTime: '17:45' },
        ],
        countsAsOfficePresence: true,
    },
    {
        id: exports.ASSISTANT_SLOT_TYPE_GLOBAL_IDS.Formation,
        label: 'Formation',
        defaultTimeRanges: [{ startTime: '09:00', endTime: '17:00' }],
        countsAsOfficePresence: false,
    },
];
/**
 * The catalog labels, in display order.
 */
exports.ASSISTANT_SLOT_TYPE_LABELS = exports.ASSISTANT_SLOT_TYPE_CATALOG.map((entry) => entry.label);
/**
 * Returns true when `label` is a member of the fixed catalog.
 *
 * @param label - the candidate label
 * @returns whether the label is a known catalog slot type
 */
function isAssistantSlotTypeLabel(label) {
    return exports.ASSISTANT_SLOT_TYPE_LABELS.includes(label);
}
/**
 * Finds the catalog entry for a label.
 *
 * @param label - the catalog label to look up
 * @returns the matching entry, or null when the label is not in the catalog
 */
function findAssistantSlotTypeCatalogEntry(label) {
    return (exports.ASSISTANT_SLOT_TYPE_CATALOG.find((entry) => entry.label === label) ?? null);
}
